export default __webpack_public_path__ + "static/media/burger_logger.965a8e16.png";